import React from 'react'
import styles from './Home.module.css'

const Home = () => {
    return (
        <div>Home</div>
    )
}

export default Home